export default function initMaxTodayDateValidator(form) {
    const elementsToAddValidators = [...form.querySelectorAll('.js-max-today-date')];

    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        } 
        if (mm < 10){
            mm = '0' + mm;
        } 

    today = yyyy + '-' + mm + '-' + dd;

    elementsToAddValidators.forEach((element) => {
        element.setAttribute('max', today);
    });
}
